import { LoadingDots } from "PFComponents/loading_dots";
import NotFoundComponent from "PFComponents/not_found/not_found";
import { CSSProperties, ReactElement } from "react";

type PageWrapperProps = {
  children: ReactElement;
  loading?: boolean;
  loadingComponent?: ReactElement;
  errors?: any[];
  errorComponent?: ReactElement;
  fade?: boolean;
  fadeStrength?: number;
  wrapperStyle?: CSSProperties;
};

export const PageWrapper = ({
  children,
  loading,
  loadingComponent = <LoadingDots circlesEnabled pageViewEnabled />,
  errors,
  errorComponent = <NotFoundComponent />,
  fade,
  fadeStrength = 0.5,
  wrapperStyle = {}
}: PageWrapperProps) => {
  if (loading && loadingComponent) {
    return loadingComponent;
  }

  if (errors && errors.length > 0 && errorComponent) {
    return errorComponent;
  }

  return <div style={{ opacity: fade ? fadeStrength : 1, ...wrapperStyle }}>{children}</div>;
};
